export const listsRoutes = {
  path: '/lists',
  children: [
    {
      name: 'lists',
      path: '',
      component: () => import('pages/Lists/Lists/index.vue'),
      meta: {
        title: 'Lists',
      },
    },
    {
      name: 'newList',
      path: 'new',
      component: () => import('pages/Lists/NewList/index.vue'),
      meta: {
        title: 'New List',
      },
    },
    {
      name: 'editList',
      path: ':id/edit',
      component: () => import('pages/Lists/EditList/index.vue'),
      meta: {
        title: 'Edit List',
      },
    },
  ],
}
